<div class="iframe-container">
  <ion-button
    fill="clear"
    color="dark"
     class="iframe-container__close-button"
    (click)="onClose()"
  >
    <ion-icon name="close"></ion-icon>
  </ion-button>
  <iframe
    [src]="iframeUrl"
    title="Opinator"
    id="opinator"
  ></iframe>
</div>